export const BREAKPOINT_SP = 481
export const ASSET_PATH = '/assets'
